import { ApiErrorsAction, ApiErrorsActionTypes } from './api-errors.action';

export interface ApiErrorsState {
  genericApiErrorCode: number;
}

export const initialApiErrorsState: ApiErrorsState = {
  genericApiErrorCode: undefined,
};

export function apiErrorsReducer(state = initialApiErrorsState, action: ApiErrorsAction): ApiErrorsState {
  switch (action.type) {
    case ApiErrorsActionTypes.SET_GENERIC_API_ERROR: {
      return {
        ...state,
        genericApiErrorCode: action.payload,
      };
    }

    case ApiErrorsActionTypes.CLEAR_GENERIC_API_ERROR: {
      return initialApiErrorsState;
    }

    default:
      return state;
  }
}

export const selectGenericApiErrorCode = (state: any) => {
  return state.apiErrors.genericApiErrorCode;
};
